export default {
  key: 'answerCountOnPresentingScreen',
  description: "On by default or Off by default sets the starting value, and members can still change it in My profile. Always on or Always off sets it for everyone in your team, and members can't change it in My profile.",
}
